export default "https://cdn-static.gokick.com/assets/ea2c661fec3366c14365f7d1c68d2a3d0c715dc9/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";